import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { OTP } from 'types';
import { client } from 'utils/api-client';

function useValidateSMSOTP(): UseMutationResult<AxiosResponse<null>, unknown, OTP> {
  return useMutation(request => client.post('auth/validate-sms-otp/', request));
}

export default useValidateSMSOTP;
